import React from "react";
import "./Footer.css";
import MsaLogo from "./MsaLogo";

const diferenciais = [
  {
    label: "Qualidade certificada",
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="12" cy="8" r="6" />
        <path d="M8.56 14.28L7 22l5-3 5 3-1.56-7.72" />
        <path d="M9 8l2 2 4-4" />
      </svg>
    ),
  },
  {
    label: "Suporte tecnico especializado",
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M3 18v-6a9 9 0 0118 0v6" />
        <path d="M21 19a2 2 0 01-2 2h-1a2 2 0 01-2-2v-3a2 2 0 012-2h3z" />
        <path d="M3 19a2 2 0 002 2h1a2 2 0 002-2v-3a2 2 0 00-2-2H3z" />
      </svg>
    ),
  },
  {
    label: "Projetos inteligentes",
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="12" cy="12" r="3" />
        <path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42" />
      </svg>
    ),
  },
  {
    label: "Parceria que gera resultados",
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z" />
      </svg>
    ),
  },
];

// Links específicos do menu
const navLinks = [
  {
    label: "Home",
    href: "/",
  },
  {
    label: "Sobre nós",
    href: "/sobre",
  },
  {
    label: "Portfólio",
    href: "/portfolio",
  },
  {
    label: "Contato",
    href: "/contatos",
  },
];

const emails = ["wagner", "marcelo", "financeiro"];

function Footer() {
  return (
    <footer className="footer">
      {/* DIFERENCIAIS */}
      <div className="footer__diferenciais">
        <div className="footer__diferenciais-container">
          {diferenciais.map((item, i) => (
            <React.Fragment key={item.label}>
              <div className="footer__diferencial-item">
                <span className="footer__diferencial-icon">
                  {item.icon}
                </span>

                <span className="footer__diferencial-label">
                  {item.label}
                </span>
              </div>

              {i < diferenciais.length - 1 && (
                <div className="footer__diferencial-sep" />
              )}
            </React.Fragment>
          ))}
        </div>
      </div>

      {/* PARTE PRINCIPAL DO FOOTER */}
      <div className="footer__top">
        <div className="footer__container">

          {/* LOGO / MARCA */}
          <div className="footer__brand">
            <div className="footer__logo">
              <MsaLogo />
            </div>

            <p className="footer__tagline">
              Solucoes inteligentes em armazenagem com qualidade,
              seguranca e eficiencia para impulsionar o seu negocio.
            </p>

            <div className="footer__brand-line" />
          </div>

          <div className="footer__divider" />

          {/* CONTATO */}
          <div className="footer__col footer__col--contact">
            <h4 className="footer__col-title">FALE CONOSCO</h4>

            <ul className="footer__contact-list">
              {/* TELEFONE */}
              <li>
                <span className="footer__icon">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81 19.79 19.79 0 01.04 1.18 2 2 0 012 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" />
                  </svg>
                </span>

                <a
                  href="tel:6299156-3162"
                  className="footer__contact-link"
                >
                  62 99156-3162
                </a>
              </li>

              {/* WHATSAPP */}
              <li>
                <span className="footer__icon footer__icon--whatsapp">
                  <svg
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                  </svg>
                </span>

                <a
                  href="https://wa.me/5562991563162"
                  target="_blank"
                  rel="noreferrer"
                  className="footer__contact-link"
                >
                  62 99156-3162
                </a>
              </li>

              {/* E-MAILS */}
              {emails.map((name) => (
                <li key={name}>
                  <span className="footer__icon">
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <rect
                        x="2"
                        y="4"
                        width="20"
                        height="16"
                        rx="2"
                      />
                      <path d="M2 7l10 7 10-7" />
                    </svg>
                  </span>

                  <a
                    href={`mailto:${name}@msaportapaletes.com.br`}
                    className="footer__contact-link"
                  >
                    {name}@msaportapaletes.com.br
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer__divider" />

          {/* ENDEREÇO */}
          <div className="footer__col footer__col--address">
            <h4 className="footer__col-title">ENDERECO</h4>

            <div className="footer__address">
              <span className="footer__icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0118 0z" />
                  <circle cx="12" cy="10" r="3" />
                </svg>
              </span>

              <p className="footer__address-text">
                Av. Contorno - Jardim Arco Verde
                <br />
                Sao Joao, Anapolis - GO,
                <br />
                75133-770
              </p>
            </div>

            <a
              href="https://share.google/HuzYWsMWXV2LDwzzn"
              target="_blank"
              rel="noreferrer"
              className="footer__maps-btn"
            >
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                width="15"
                height="15"
              >
                <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0118 0z" />
                <circle cx="12" cy="10" r="3" />
              </svg>

              Google Maps
            </a>
          </div>

          <div className="footer__divider" />

          {/* LINKS RÁPIDOS */}
          <div className="footer__col footer__col--links">
            <h4 className="footer__col-title">LINKS RAPIDOS</h4>

            <ul className="footer__links">
              {navLinks.map((item) => (
                <li key={item.label}>
                  <a
                    href={item.href}
                    className="footer__nav-link"
                  >
                    <span className="footer__arrow">
                      &#8250;
                    </span>

                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer__divider" />

          {/* REDES SOCIAIS */}
          <div className="footer__col footer__col--social">
            <h4 className="footer__col-title">SIGA-NOS</h4>

            <div className="footer__social">

              {/* FACEBOOK */}
              <a
                href="https://www.facebook.com/p/MSA-Representa%C3%A7%C3%B5es-61550933945681/"
                target="_blank"
                rel="noreferrer"
                className="footer__social-btn"
                aria-label="Facebook"
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  width="18"
                  height="18"
                >
                  <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z" />
                </svg>
              </a>

              {/* INSTAGRAM */}
              <a
                href="https://www.instagram.com/msaportapaletes/"
                target="_blank"
                rel="noreferrer"
                className="footer__social-btn"
                aria-label="Instagram"
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  width="18"
                  height="18"
                >
                  <rect
                    x="2"
                    y="2"
                    width="20"
                    height="20"
                    rx="5"
                    ry="5"
                  />
                  <circle cx="12" cy="12" r="4" />
                  <circle
                    cx="17.5"
                    cy="6.5"
                    r="1"
                    fill="currentColor"
                    stroke="none"
                  />
                </svg>
              </a>

              {/* LINKEDIN */}
              <a
                href="https://br.linkedin.com/company/msa-representa%C3%A7%C3%B5es"
                target="_blank"
                rel="noreferrer"
                className="footer__social-btn"
                aria-label="LinkedIn"
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  width="18"
                  height="18"
                >
                  <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z" />
                  <circle cx="4" cy="4" r="2" />
                </svg>
              </a>

            </div>
          </div>

        </div>
      </div>

      {/* RODAPÉ INFERIOR */}
      <div className="footer__bottom">
        <div className="footer__accent-line" />

        <p className="footer__copy">
          &#169; 2026 MSA Porta Paletes. Todos os direitos reservados.
        </p>
      </div>
    </footer>
  );
}

export default Footer;